import * as React from 'react';

import Icon from 'src/components/icon';
import { CountWrapper } from './style';

class MessageCount extends React.Component {
  render() {
    const {
      thread: { messageCount },
      active,
    } = this.props;

    return (
      <CountWrapper active={active}>
        <Icon
          style={{ pointerEvents: 'none' }}
          glyph="message-simple"
          size={24}
        />
        <span>{messageCount}</span>
      </CountWrapper>
    );
  }
}

export default MessageCount;
